import { gql } from "graphql-tag";

export const query = gql`
  query SlideoutApplications($interestId: ID!) {
    interest(id: $interestId) {
      id
      organization {
        id
        interestLists {
          id
        }
      }
      interestList {
        property {
          features {
            id
            name
          }
        }
      }
      documents {
        id
      }
    }

    otherInterests(interestId: $interestId) {
      firstName
      householdCount
      householdGrossAnnualIncome
      id
      lastName
      interestListName
      interestListId
      status
      submittedAt
      updateRequest {
        isActive
        updateUrl
      }
    }
  }
`;
